export enum Endpoints {
  login = '/usuarios/login',
  products = '/produtos',
  product = '/produto',
  services = '/servicos',
  users = '/usuarios',
  employee = '/funcionarios',
  students = '/alunos',
  plans = '/planos',
  gruops = '/grupos',
  exercise = '/exercicios',
  quickSales = '/vendas-rapidas',
  gyms = '/academias',
  costCenter = '/centro-custo',
  units = '/unidades',
  consultant = '/consultores',
  client = '/clientes',
  card = '/cartoes',
  perfis = '/perfis',
 
}
